var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateChildren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9e668d3b7e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 136.636719 161.304688 L 238.636719 161.304688 L 238.636719 213.804688 L 136.636719 213.804688 Z M 136.636719 161.304688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "305772206c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.878906 45 L 150 45 L 150 330 L 17.878906 330 Z M 17.878906 45 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc498f7e6e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 225.660156 45 L 358 45 L 358 330 L 225.660156 330 Z M 225.660156 45 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9e668d3b7e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#01b454",
    d: "M 203.316406 213.6875 L 203.316406 202.476562 L 136.683594 202.476562 L 136.683594 172.515625 L 203.316406 172.515625 L 203.316406 161.304688 L 238.304688 187.496094 Z M 203.316406 213.6875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#305772206c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#01b454",
    d: "M 28.835938 45.046875 C 24.898438 44.960938 21.21875 47.101562 19.25 50.4375 C 17.195312 53.863281 17.195312 58.144531 19.25 61.566406 C 21.21875 64.90625 24.898438 67.046875 28.835938 66.960938 L 40.050781 66.960938 L 40.050781 286.121094 C 40.050781 310.175781 59.828125 329.953125 83.882812 329.953125 C 107.941406 329.953125 127.714844 310.175781 127.714844 286.121094 L 127.714844 66.960938 L 138.417969 66.960938 C 142.355469 67.046875 146.035156 64.90625 148.003906 61.566406 C 150.058594 58.144531 150.058594 53.863281 148.003906 50.4375 C 146.035156 47.101562 142.355469 44.960938 138.417969 45.046875 Z M 61.96875 66.960938 L 105.800781 66.960938 L 105.800781 110.792969 L 61.96875 110.792969 Z M 61.96875 132.710938 L 105.800781 132.710938 L 105.800781 286.121094 C 105.800781 298.191406 95.957031 308.039062 83.882812 308.039062 C 71.8125 308.039062 61.96875 298.191406 61.96875 286.121094 Z M 61.96875 132.710938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc498f7e6e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#01b454",
    d: "M 236.617188 45.046875 C 232.679688 44.960938 229 47.101562 227.03125 50.4375 C 224.976562 53.863281 224.976562 58.144531 227.03125 61.566406 C 229 64.90625 232.679688 67.046875 236.617188 66.960938 L 247.832031 66.960938 L 247.832031 286.121094 C 247.832031 310.175781 267.609375 329.953125 291.664062 329.953125 C 315.722656 329.953125 335.496094 310.175781 335.496094 286.121094 L 335.496094 66.960938 L 346.199219 66.960938 C 350.136719 67.046875 353.816406 64.90625 355.785156 61.566406 C 357.839844 58.144531 357.839844 53.863281 355.785156 50.4375 C 353.816406 47.101562 350.136719 44.960938 346.199219 45.046875 Z M 269.75 66.960938 L 313.582031 66.960938 L 313.582031 110.792969 L 269.75 110.792969 Z M 269.75 132.710938 L 313.582031 132.710938 L 313.582031 286.121094 C 313.582031 298.191406 303.734375 308.039062 291.664062 308.039062 C 279.59375 308.039062 269.75 298.191406 269.75 286.121094 Z M 269.75 132.710938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateChildren);
export default __webpack_public_path__ + "static/media/create-children.81fb88f06b6fdeed56f98f549de1b0e6.svg";
export { ForwardRef as ReactComponent };